import React from 'react'

export default function Press() {
  return (
    <div className='press-container'></div>
  )
}
